import { Sentry } from '@/lib/sentry';

const DSN = import.meta.env.VITE_SENTRY_DSN;

export const logger = {
  error(error, context = {}) {
    console.error(error);
    if (DSN) {
      Sentry.captureException(error, { extra: context });
    }
  },

  warn(message, context = {}) {
    console.warn(message);
    if (DSN) {
      Sentry.captureMessage(message, { level: 'warning', extra: context });
    }
  },

  info(message, context = {}) {
    console.info(message);
    if (DSN) {
      Sentry.captureMessage(message, { level: 'info', extra: context });
    }
  },

  setUser(user) {
    if (DSN && user) {
      Sentry.setUser({ id: user.id, email: user.email });
    }
  },

  clearUser() {
    if (DSN) {
      Sentry.setUser(null);
    }
  },
};
